// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailPendingRouteImport } from './routes/verify-email-pending'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as ToolsRouteImport } from './routes/tools'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as GetStartedConfirmedRouteImport } from './routes/get-started-confirmed'
import { Route as GetStartedRouteImport } from './routes/get-started'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DeleteAccountRouteImport } from './routes/delete-account'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CompleteProfileRouteImport } from './routes/complete-profile'
import { Route as CaseStudiesRouteImport } from './routes/case-studies'
import { Route as CareersRouteImport } from './routes/careers'
import { Route as CallBookedRouteImport } from './routes/call-booked'
import { Route as BrandingGalleryRouteImport } from './routes/branding-gallery'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesVisionToLaunchRouteImport } from './routes/services.vision-to-launch'
import { Route as ServicesSoftwareAuditRouteImport } from './routes/services.software-audit'
import { Route as ServicesOngoingSupportRouteImport } from './routes/services.ongoing-support'
import { Route as ServicesMarketingRouteImport } from './routes/services.marketing'
import { Route as ServicesClientPortalRouteImport } from './routes/services.client-portal'
import { Route as ServicesAiWebAppDesignRouteImport } from './routes/services.ai-web-app-design'
import { Route as DashboardIndexRouteImport } from './routes/dashboard.index'
import { Route as DashboardProgressRouteImport } from './routes/dashboard.progress'
import { Route as DashboardMessagesRouteImport } from './routes/dashboard.messages'
import { Route as DashboardDocumentsRouteImport } from './routes/dashboard.documents'
import { Route as DashboardCalendarRouteImport } from './routes/dashboard.calendar'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'

const VerifyEmailPendingRoute = VerifyEmailPendingRouteImport.update({
            id: '/verify-email-pending',path: '/verify-email-pending',getParentRoute: () => rootRouteImport
          })
const VerifyEmailRoute = VerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => rootRouteImport
          })
const ToolsRoute = ToolsRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => rootRouteImport
          })
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
            id: '/terms-of-service',path: '/terms-of-service',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ProfileRoute = ProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const GetStartedConfirmedRoute = GetStartedConfirmedRouteImport.update({
            id: '/get-started-confirmed',path: '/get-started-confirmed',getParentRoute: () => rootRouteImport
          })
const GetStartedRoute = GetStartedRouteImport.update({
            id: '/get-started',path: '/get-started',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const DeleteAccountRoute = DeleteAccountRouteImport.update({
            id: '/delete-account',path: '/delete-account',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CompleteProfileRoute = CompleteProfileRouteImport.update({
            id: '/complete-profile',path: '/complete-profile',getParentRoute: () => rootRouteImport
          })
const CaseStudiesRoute = CaseStudiesRouteImport.update({
            id: '/case-studies',path: '/case-studies',getParentRoute: () => rootRouteImport
          })
const CareersRoute = CareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => rootRouteImport
          })
const CallBookedRoute = CallBookedRouteImport.update({
            id: '/call-booked',path: '/call-booked',getParentRoute: () => rootRouteImport
          })
const BrandingGalleryRoute = BrandingGalleryRouteImport.update({
            id: '/branding-gallery',path: '/branding-gallery',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesRoute
          })
const ServicesVisionToLaunchRoute = ServicesVisionToLaunchRouteImport.update({
            id: '/vision-to-launch',path: '/vision-to-launch',getParentRoute: () => ServicesRoute
          })
const ServicesSoftwareAuditRoute = ServicesSoftwareAuditRouteImport.update({
            id: '/software-audit',path: '/software-audit',getParentRoute: () => ServicesRoute
          })
const ServicesOngoingSupportRoute = ServicesOngoingSupportRouteImport.update({
            id: '/ongoing-support',path: '/ongoing-support',getParentRoute: () => ServicesRoute
          })
const ServicesMarketingRoute = ServicesMarketingRouteImport.update({
            id: '/marketing',path: '/marketing',getParentRoute: () => ServicesRoute
          })
const ServicesClientPortalRoute = ServicesClientPortalRouteImport.update({
            id: '/client-portal',path: '/client-portal',getParentRoute: () => ServicesRoute
          })
const ServicesAiWebAppDesignRoute = ServicesAiWebAppDesignRouteImport.update({
            id: '/ai-web-app-design',path: '/ai-web-app-design',getParentRoute: () => ServicesRoute
          })
const DashboardIndexRoute = DashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardRoute
          })
const DashboardProgressRoute = DashboardProgressRouteImport.update({
            id: '/progress',path: '/progress',getParentRoute: () => DashboardRoute
          })
const DashboardMessagesRoute = DashboardMessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => DashboardRoute
          })
const DashboardDocumentsRoute = DashboardDocumentsRouteImport.update({
            id: '/documents',path: '/documents',getParentRoute: () => DashboardRoute
          })
const DashboardCalendarRoute = DashboardCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => DashboardRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })





const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const DashboardRouteChildren = {
  DashboardCalendarRoute: DashboardCalendarRoute,DashboardDocumentsRoute: DashboardDocumentsRoute,DashboardMessagesRoute: DashboardMessagesRoute,DashboardProgressRoute: DashboardProgressRoute,DashboardIndexRoute: DashboardIndexRoute
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(DashboardRouteChildren)




const ServicesRouteChildren = {
  ServicesAiWebAppDesignRoute: ServicesAiWebAppDesignRoute,ServicesClientPortalRoute: ServicesClientPortalRoute,ServicesMarketingRoute: ServicesMarketingRoute,ServicesOngoingSupportRoute: ServicesOngoingSupportRoute,ServicesSoftwareAuditRoute: ServicesSoftwareAuditRoute,ServicesVisionToLaunchRoute: ServicesVisionToLaunchRoute,ServicesIndexRoute: ServicesIndexRoute
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(ServicesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AdminRoute: AdminRoute,BlogRoute: BlogRouteWithChildren,BrandingGalleryRoute: BrandingGalleryRoute,CallBookedRoute: CallBookedRoute,CareersRoute: CareersRoute,CaseStudiesRoute: CaseStudiesRoute,CompleteProfileRoute: CompleteProfileRoute,ContactRoute: ContactRoute,DashboardRoute: DashboardRouteWithChildren,DeleteAccountRoute: DeleteAccountRoute,FaqRoute: FaqRoute,ForgotPasswordRoute: ForgotPasswordRoute,GetStartedRoute: GetStartedRoute,GetStartedConfirmedRoute: GetStartedConfirmedRoute,LoginRoute: LoginRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ProfileRoute: ProfileRoute,ResetPasswordRoute: ResetPasswordRoute,ServicesRoute: ServicesRouteWithChildren,SignupRoute: SignupRoute,TermsOfServiceRoute: TermsOfServiceRoute,ToolsRoute: ToolsRoute,VerifyEmailRoute: VerifyEmailRoute,VerifyEmailPendingRoute: VerifyEmailPendingRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)